import { useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { format } from "date-fns";

import styles from "./Reason.module.scss";
import { Table } from "react-bootstrap";
import CustomerPicker from "./CustomerPicker";

function InitiatedDetails({
  details,
  setDetails,
  request,
  customerData,
  data,
}) {
  // console.log("data", data);

  const [rider, setRider] = useState(false);
  const handleModalClose = () => {
    setDetails(false);
  };

  const handleSubmit = () => {
    setDetails(false);
    setRider(true);
  };

  const headers = [
    { key: "id", label: "ID" },
    { key: "brand", label: "Brand" },
    { key: "exp_date", label: "Exp Date" },
    { key: "qty", label: "Return Qty" },
    { key: "quantity", label: "Qty" },
    { key: "quantitytype", label: "Qty Typr" },
    // { key: "created_at", label: "Created At" },
    { key: "name", label: "Name" },
  ];

  const bloodHeaders = [
    { key: "id", label: "ID" },
    { key: "brand", label: "Brand" },
    { key: "name", label: "Name" },
    { key: "order_by", label: "Order By" },
  ];

  return (
    <>
      <Dialog open={details} onClose={handleModalClose}>
        <DialogContent style={{ paddingBottom: "0" }}>
          <div className={styles.title}>{request?.reason}</div>

          <hr />

          <div className={styles.formContainer}>
            {request?.product === "blood" ? (
              <Table borderless responsive>
                <thead>
                  <tr className={styles.TableHeadRow}>
                    {bloodHeaders.map((row) => (
                      <td key={row.key}>{row.label}</td>
                    ))}
                  </tr>
                </thead>
                {data?.length > 0 ? (
                  <tbody>
                    {data.map((items, index) => (
                      <tr key={index} className={styles.tableBodyRow}>
                        <td style={{ width: "10vw" }}>{items?.id}</td>
                        <td style={{ width: "10vw" }}>
                          {items?.brand === null ? "N/A" : items?.brand}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.name === null ? "N/A" : items?.name}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.order_by
                            ? format(
                                new Date(Number(items.order_by)),
                                "dd/MM/yyyy",
                              )
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="d-flex justify-content-center align-items-center">
                    <tr>
                      <td colSpan={6}>No data found</td>
                    </tr>
                  </tbody>
                )}
              </Table>
            ) : (
              <Table borderless responsive>
                <thead>
                  <tr className={styles.TableHeadRow}>
                    {headers.map((row) => (
                      <td key={row.key}>{row.label}</td>
                    ))}
                  </tr>
                </thead>
                {data?.length > 0 ? (
                  <tbody>
                    {data.map((items, index) => (
                      <tr key={index} className={styles.tableBodyRow}>
                        <td style={{ width: "10vw" }}>{items?.item_id}</td>
                        <td style={{ width: "10vw" }}>
                          {items?.brand === null ? "N/A" : items?.brand}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.exp_date === null ? "N/A" : items?.exp_date}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.qty === null ? "N/A" : items?.qty}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.quantity === null ? "N/A" : items?.quantity}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {items?.quantitytype === null
                            ? "N/A"
                            : items?.quantitytype}
                        </td>
                        {/* <td style={{ width: "10vw" }}>{items?.exp_date}</td> */}
                        <td style={{ width: "10vw" }}>
                          {items?.name === null ? "N/A" : items?.name}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="d-flex justify-content-center align-items-center">
                    <tr>
                      <td colSpan={6}>No data found</td>
                    </tr>
                  </tbody>
                )}
              </Table>
            )}
          </div>
        </DialogContent>

        <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
          {/* <div
          style={{
            cursor: "pointer",
            color: "#253858",
            backgroundColor: "#DFE1E6",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleModalClose}
        >
          No
        </div> */}
          <div
            style={{
              cursor: "pointer",
              color: "#ffffff",
              backgroundColor: "#b70303",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
            }}
            onClick={handleSubmit}
          >
            {"Proceed"}
          </div>
        </DialogActions>
      </Dialog>

      <CustomerPicker
        rider={rider}
        setRider={setRider}
        id={request?.order_id}
        title={request?.product}
        values={request}
      />
    </>
  );
}

export default InitiatedDetails;
